<template>
  <div
    v-if="options?.show"
    class="absolute flex flex-col justify-stretch"
    :class="float({ class: 'p-4' })"
    :style="`left: ${options.position.x}px; top: ${options.position.y}px`"
  >
    <button
      v-for="item in options.items"
      :key="item.label"
      class="px-2 py-1 hover:bg-accent"
      @click="item.onClick"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { float } from '@carvia/theme/lib/cva/float.ts';
export interface GanttDropDownOptions {
  show: boolean;
  position: {
    x: number;
    y: number;
  };
  items: { label: string; onClick: () => void }[];
}

defineProps<{
  options: GanttDropDownOptions | null;
}>();
</script>
